import { IconType } from '@aksia/infrastructure';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class EntitySearchItemService {
  constructor() {}

  protected readonly icons: { [key in number]: IconType } = {
    0: 'Person', //'faSolidUser'
    1: 'Attach_Money', //'faSolidDollarSign'
    2: 'Graph_4', //'faSolidBezierCurve'
    3: 'Show_Chart', //'faSolidChartLine'
    4: 'Person', //'faSolidUser'
    5: 'Contacts', //'faSolidAddressCard'
    6: 'Person', //'faSolidUser'
    7: 'Folder_Open', //'faSolidFolderOpen'
    8: 'Confirmation_Number', //'faSolidTicket',
    99: 'Contacts',
  };

  protected readonly iconsColors: { [key in number]: string } = {
    0: 'text-[#2f7ed8]',
    1: 'text-[#1a7a1a]',
    2: 'text-[#852e45]',
    3: 'text-[#000088]',
    4: 'text-[#2f7ed8]',
    6: 'text-[#2f7ed8]',
    7: 'text-[#2d2d2d]',
    8: 'text-[#2d2d2d]',
  };

  processIcon(entityTypeId: number): IconType | undefined {
    return this.icons[entityTypeId] || undefined;
  }

  processIconColor(entityTypeId: number) {
    return this.iconsColors[entityTypeId] || '';
  }
}
